"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdaptedConfig = void 0;
var _config = require("../../../config");
var _url = require("../../../utils/url");
const getAdaptedConfig = _ref => {
  let {
    brandId,
    ...config
  } = _ref;
  return {
    brandId,
    brandColor: {
      main: config.color
    },
    brandName: config.brand_name,
    captchaSiteKey: config.captcha_site_key,
    cookiePolicyPageUrl: (0, _url.getUrlWithProtocol)(config.cookie_policy_link),
    dateFormat: config.date_format,
    dialCode: config.dial_code,
    domain: config.domain,
    fontSize: config.font_size,
    locale: config.locale,
    loginPage: (0, _url.getUrlWithProtocol)(config.login_page),
    oldPasswordResetPageUrl: (0, _url.getUrlWithProtocol)(config.old_password_reset_page_url),
    pageBackgroundColor: config.page_background_color,
    privacyPageUrl: (0, _url.getUrlWithProtocol)(config.privacy_link),
    stripePublicKey: config.stripe_public_key,
    termsPageUrl: (0, _url.getUrlWithProtocol)(config.terms_link),
    windowApiKeyReceivedEventKey: _config.windowApiKeyReceivedEventKey,
    isInclusivePrices: !!config.is_inclusive_prices
  };
};
exports.getAdaptedConfig = getAdaptedConfig;